import { globalHistory } from "svelte-routing/src/history"
export function dataLayerPush(eventname: string, conversionValue?: string | number) {
    if (window.dataLayer) {
        window.dataLayer.push({ 'event': eventname, conversionValue })
    }
}

export function historyChangeEventDispatcher() {
    const times = [15, 30, 60, 180, 300, 480, 600].map((v) => v * 1000);
    let prevPathname = window.location.pathname;
    let timers: ReturnType<typeof setTimeout>[] = []

    function setTimerEvent(path: string) {
        for (const timer of timers) clearTimeout(timer);
        prevPathname = path
        timers = times.map((v) => setTimeout(() => {
            const str = v < 60000 ? "second" : "min";
            const t = v < 60000 ? v / 1000 : v / 60000;
            dataLayerPush(`${t}_${str}`)
        }, v))
    }

    globalHistory.listen((d) => {
        if (d.location.pathname === prevPathname) return;

        setTimerEvent(d.location.pathname)
    })

    // Initiate
    setTimerEvent(prevPathname)
}